module.exports = __webpack_public_path__ + "img/CI.c9dafc9b.svg";